import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: window.innerWidth >= 768
}

const moreThan768Slice = createSlice({
    name: 'moreThan768',
    initialState,
    reducers: {
        moreThan768(state) {
            state.value = true;
        },
        lessThan768(state) {
            state.value = false;
        }
    }
});

export const moreThan768Actions = moreThan768Slice.actions;

export default moreThan768Slice.reducer;